import {
    IonPage, IonContent, IonAlert, IonInput, IonButton
} from '@ionic/react';
import React, {Component} from "react";
import './css/PhoneCancellationAccount.css';
import cookieUtil from "../../../utils/cookieUtil";
import {AccountCancel, AccountCancelForChannelApp, AccountCancelRepealForApp} from "./Service";
import {getQueryVariable} from "../../../utils/commonFunction";
import {getTokenParam} from "../Service";
import {getUserInfo} from "../kefu/phone/Service";


class AppleCancellationAccount extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currPage: 1,
            isShowTip: false,
            isChannel: true,
            isYes: false,
            showTipMsg: null,
            IdCard: '',
            realName: '',
            token: '',
            isIdCardErr: false,
            isRealNameErr: false,
            from: null
        }
    }

    componentDidMount() {
        let pms = getQueryVariable('pm');
        if (pms != null) {
            this.getTokenParams(pms);
        } else if (cookieUtil.has("access_token")) {
            this.setState({
                token: cookieUtil.get('access_token')
            })
            this.queryUserInfo();
        }
        let from = getQueryVariable('from');
        if(from!=null && from!=""){
            this.setState({
                from
            })
        } else {
            window.location.href = "/phone/accountCancellation"
        }
    }


    getTokenParams = (pms) => {
        let params = {
            pagePm: pms
        }
        getTokenParam(params, '?pagePm=' + pms).then(ret => {
            if (ret.code === '10000') {
                cookieUtil.put("access_token", ret.data.accessToken);
                this.setState({
                    token: ret.data.accessToken
                });
                this.queryUserInfo();
            } else {
                alert(ret.msg);
            }
        })
    }
    queryUserInfo = () => {
        if (cookieUtil.has("access_token") && !cookieUtil.has("userInfo")) {
            let param = {
                "access_token": cookieUtil.get("access_token")
            }
            getUserInfo(param).then(res => {
                if (res.code === '10000') {
                    cookieUtil.putExpire("userInfo", JSON.stringify(res.data))
                } else {
                    alert(res.msg);
                }
            }).catch(err => {
                console.log(err);
            });
        } 
    }

    /**
     * 关闭弹框控制
     */
    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null,
        })
    }
    /**
     * 检测身份证
     */
    checkIdCard = (par) => {
        console.log(par);
        if (par == null || par === "" || (par.length !== 15 && par.length !== 18)) {
            this.setState({
                isIdCardErr: true,
            })
        }
    }
    /**
     * 检测姓名
     */
    checkRealName = (par) => {
        if (par == null || par === "") {
            this.setState({
                isRealNameErr: true,
            })
        }
    }
    /**
     * 提交
     */
    butSubmit = () => {
        const {token, IdCard, realName, isYes, isChannel} = this.state;
        if (token === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请先登录在操作'
            })
            return;
        }
        if (!isChannel) {
            if (realName === '') {
                this.setState({
                    isShowTip: true,
                    isRealNameErr: '请输入真实姓名'
                })
                return;
            }
            if (IdCard.length !== 15 && IdCard.length !== 18) {
                this.setState({
                    isIdCardErr: true,
                    showTipMsg: '请输入有效身份证号'
                })
                return;
            }
        }
        if (!isYes) {
            this.setState({
                isShowTip: true,
                showTipMsg: '请阅读并接受《账号注销须知》'
            })
            return;
        }
        const urlParams = {
            'access_token': token,
            'realName': realName,
            'idCard': IdCard,
            'applyReason': ''
        }
        console.log("cancel=" + urlParams)
        if (isChannel) {
            AccountCancelForChannelApp(urlParams).then(ret => {
                if (ret.code === '10000') {
                    this.setState({
                        currPage: 3
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        } else {
            AccountCancel(urlParams).then(ret => {
                if (ret.code === '10000') {
                    this.setState({
                        currPage: 2
                    })
                } else {
                    this.setState({
                        isShowTip: true,
                        showTipMsg: ret.msg
                    })
                }
            }).catch(err => {
                console.log(err);
            });
        }
    }
    /**
     * 撤回账号注销
     */
    butCancelRepeal = () => {
        if (this.state.token === '') {
            this.setState({
                isShowTip: true,
                showTipMsg: '请先登录在操作'
            })
            return;
        }
        const urlParams = {
            'access_token': this.state.token,
        }
        AccountCancelRepealForApp(urlParams).then(ret => {
            if (ret.code === '10000') {
                this.setState({
                    currPage: 1
                })
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                })
            }
        }).catch(err => {
            console.log(err);
        });
    }

    render() {
        return (
            <IonPage>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
                <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1"/>
                <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <title>注销账号</title>
                <IonContent fullscreen>
                    {this.state.currPage === 1 &&
                        <div className="logoff-box_ca_phone">
                            <div className="logoff-cot">
                                <p style={{margin: '30px auto', fontSize: '24px'}}>尊敬的玩家您好:</p>
                                <p className="focus" style={{margin: '30px auto', fontSize: '24px'}}>
                                    您正在进行注销操作，注销后该游戏ID在本游戏中的所有游戏信息都会被清除，请确认是否注销。。
                                </p>
                            </div>
                            <p className="agree">
                                <input type="checkbox" onClick={() => this.setState({isYes: !this.state.isYes})}
                                       style={{
                                           width: '32px',
                                           height: '32px',
                                           verticalAlign: 'middle',
                                           margin: '0 20px',
                                       }}/>我已详细阅读并同意
                                <a href={"https://wfw.fuyuncc.com/pc/accountCancel/" + this.state.from + "/CancellationProtocolDetail.html"}
                                   className="a-link">《账号注销须知》</a>
                            </p>
                            <a className="btn-cancel" onClick={() => this.butSubmit()}>同意注销</a>
                        </div>
                    }
                    {this.state.currPage === 2 &&
                        <div className="logoff-box_ca_phone">
                            <div className="logoff-cot">
                                <div className="get-box">
                                    <p style={{margin: '30px auto'}}><span className="get-icon"></span></p>
                                    <h3>您已成功提交注销申请</h3>
                                    <span className="tip">感谢您对本游戏的支持</span>
                                </div>
                                <p style={{margin: '30px auto'}}>
                                    您已成功提交注销申请（ID已锁定），15天（犹豫期）后该账号将予以注销。

                                </p>

                            </div>
                            {/*<a onClick={() => this.butCancelRepeal()} className="btn-cancel"*/}
                            {/*   style={{marginTop: '120px'}}>撤销注销</a>*/}
                        </div>
                    }
                    {this.state.currPage === 3 &&
                        <div className="logoff-box_ca_phone">
                            <div className="logoff-cot">
                                <div className="get-box">
                                    <p style={{margin: '30px auto'}}><span className="get-icon"></span></p>
                                    <h3>您已成功提交注销申请</h3>
                                    <span className="tip">感谢您对本游戏的支持</span>
                                </div>
                                <p style={{margin: '30px auto'}}>
                                    您已成功提交注销申请（ID已锁定），7天（犹豫期）后该账号将予以注销。
                                </p>

                            </div>
                            {/*<a onClick={() => this.butCancelRepeal()} className="btn-cancel"*/}
                            {/*   style={{marginTop: '120px'}}>撤销注销</a>*/}
                        </div>
                    }
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
};

export default AppleCancellationAccount;
